import { gql } from '@apollo/client';

const RE_CAPTURE_AUTO_EVENTS = gql`
  mutation recaptureAutoEvents($input: RecaptureAutoEventsInput) {
    recaptureAutoEvents(input: $input) {
      isSuccess
      message
    }
  }
`;

export default RE_CAPTURE_AUTO_EVENTS;
